import { EmailIcon } from '@/icons';
import { NavItem, SubNavItem } from './Header.types';
import {
  DiscordIcon,
  MediumIcon,
  SubstackIcon,
  TelegramIcon,
  TreasuryIcon,
  TwitterIcon,
  VotingIcon,
} from '@onbeam/icons/business';

export const socials: SubNavItem[] = [
  {
    label: 'X (Twitter)',
    icon: TwitterIcon,
    href: 'https://twitter.com/BuildOnBeam',
    isExternal: true,
  },
  {
    label: 'Telegram',
    icon: TelegramIcon,
    href: 'https://t.me/buildonbeam_news',
    isExternal: true,
  },
  {
    label: 'Discord',
    icon: DiscordIcon,
    href: 'http://discord.gg/beamcommunity',
    isExternal: true,
  },
  {
    label: 'Medium',
    icon: MediumIcon,
    href: 'https://medium.com/@onbeam',
    isExternal: true,
  },
  {
    label: 'Substack',
    icon: SubstackIcon,
    href: 'https://onbeam.substack.com/',
    isExternal: true,
  },
  {
    label: 'Email',
    icon: EmailIcon,
    href: 'mailto:hello@onbeam.com',
    isExternal: true,
  },
];

export const navItems: NavItem[] = [
  { href: '/', label: 'Home' },
  { href: '/ecosystem', label: 'Ecosystem' },
  {
    label: 'Governance',
    subMenu: {
      variant: 'default',
      items: [
        {
          label: 'Governance forum',
          subLabel: 'Community governance forum.',
          icon: TreasuryIcon,
          href: 'https://gov.onbeam.com/',
          isExternal: true,
        },
        {
          label: 'Snapshot voting',
          subLabel: 'Off-chain voting platform for Beam.',
          icon: VotingIcon,
          href: 'https://vote.onbeam.com/',
          isExternal: true,
        },
      ],
    },
  },
  { href: '/mission', label: 'Mission' },
  { href: '/news', label: 'News' },
  {
    label: 'Socials',
    subMenu: {
      variant: 'compact',
      items: socials,
    },
  },
];

export const isActivePath = (pathname: string, href: string) => {
  if (pathname === href) return true;
  const item = navItems.find((item) => item.href === href);
  if (!item || !item.associatedRoutes) return false;
  return item.associatedRoutes.some((regexp) => regexp.test(pathname));
};
